import { IonContent, IonPage, IonImg, useIonViewDidLeave } from '@ionic/react';
import { useContext, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y } from 'swiper';
import { PdfContext } from '../components/PdfViewer';

const IRLDating: React.FC = () => {
  const { setModalVisible, setDesktopPdf, setMobilePdf } = useContext(PdfContext);
  const [swiper, setSwiper] = useState<SwiperCore>();
  // set the swiper slide to the first one when the component is mounted
  useIonViewDidLeave(() => {
    swiper?.slideTo(0);
  }, [swiper]);
  return (
    <>
      <IonPage>
        <IonContent fullscreen>
          <Swiper
            initialSlide={0}
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            onSwiper={(swiper) => setSwiper(swiper)}
            slidesPerView={1}
            // loop={true}
            navigation
            pagination={{ clickable: true }}
            spaceBetween={0}
            centeredSlides={true}
            breakpoints={{
              768: {
                slidesPerView: 1.2,
                spaceBetween: -20
              },
              1024: {
                slidesPerView: 1.4,
                spaceBetween: -120
              },
            }}
          >
            <SwiperSlide>
              <div className="container-inner">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#00ff7e', color: '#fff' }}>Hẹn hò trực tiếp 101</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030', paddingTop: '0.1rem' }}>
                    <p>
                      Thông tin dành cho tất cả những ai đã có một cuộc trò chuyện thú vị qua mạng nhưng vẫn chưa biết phải làm gì tiếp theo khi bắt đầu chuyển sang gặp gỡ đối phương ngoài đời thực. Những hướng dẫn dưới đây sẽ giúp bạn dễ dàng chuyển từ trò chuyện trực tuyến sang gặp mặt trực tiếp một cách thoải mái mà không tạo ra bất kỳ lo lắng, áp lực nào!
                    </p>
                  </div>
                </div>
              </div>
            </SwiperSlide>
            {/* <SwiperSlide>
            <div className="container-inner design-video">
              <div className="d-flex">
                <h1 className='container-title'>Heading of the video</h1>
                <div className='container-content'>
                  <div className="video-container">
                    <div className="thumbnail">
                      <IonImg src='assets/img/video-thumb.png'></IonImg>
                    </div>
                    <div className="description-outer">
                      <div className="description">
                        <h3 className='title'>
                          Video title
                        </h3>
                        <p>Video subtitle, this is a dummy description, lorem ipsum dolor sit amet.</p>
                      </div>
                      <a href="/">CLICK TO VIEW</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide> */}
            <SwiperSlide>
              <div className="container-inner design-one">
                <div className="d-flex">
                  <h1 className='container-title' style={{ background: '#26e8c8', color: '#fff' }}>Bài học vỡ lòng: Buổi hẹn đầu tiên</h1>
                  <div className='container-content' style={{ background: '#fff', color: '#303030' }}>
                    <p className='hide-desktop'>Tạm biệt những lo lắng bằng những lời khuyên bất bại cho buổi hẹn đầu tiên!</p>
                    <IonImg src='assets/img/irl-fcfc-thumb-01.png'></IonImg>
                    <div className='flex'>
                      <p className='hide-mobile' style={{ maxWidth: '550px' }}>Tạm biệt những lo lắng bằng những lời khuyên bất bại cho buổi hẹn đầu tiên!</p>
                      <button onClick={() => {
                        setDesktopPdf("/assets/pdf/VN_FirstClassFirstDates.pdf");
                        setMobilePdf("/assets/pdf/VN_FirstClassFirstDates(m).pdf");
                        setModalVisible(true);
                      }} style={{ color: "#fff", background: "#26e8c8" }}>Hẹn hò thôi nào</button>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
        </IonContent>
      </IonPage>
    </>
  );
};

export default IRLDating;
